import type { Table } from "@tanstack/react-table";
import { Button } from "@carry/ui";

export function TablePagination<T>({ table }: { table: Table<T> }) {
  const { pageIndex, pageSize } = table.getState().pagination;
  const total = table.getFilteredRowModel().rows.length;
  const pageCount = table.getPageCount();
  const from = total === 0 ? 0 : pageIndex * pageSize + 1;
  const to = Math.min((pageIndex + 1) * pageSize, total);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 224,
        right: 0,
        height: 44,
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "0 24px",
        background: "var(--bg)",
        borderTop: "0.5px solid var(--rule-softer)",
        zIndex: 40,
        fontSize: 12,
      }}
    >
      {/* 件数表示 (左) */}
      <span
        style={{
          fontFamily: "var(--f-mono)",
          fontSize: 11,
          color: "var(--ink-3)",
          whiteSpace: "nowrap",
        }}
      >
        {total === 0 ? "0 件" : `${from}–${to} / ${total} 件`}
      </span>

      <span style={{ flex: 1 }} />

      {/* ナビゲーション (右) */}
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        ‹ 前へ
      </Button>
      <span
        style={{
          fontFamily: "var(--f-mono)",
          fontSize: 11,
          color: "var(--ink-4)",
          minWidth: 60,
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        {pageCount > 0 ? `${pageIndex + 1} / ${pageCount}` : "—"}
      </span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
      >
        次へ ›
      </Button>
    </div>
  );
}
